export default {
  "content": "<path d=\"M18.5 18h4v2h-4v4h-2v-4h-4v-2h4v-4h2v4z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 4a3 3 0 013 3v7h-2v-3.5h-17V17a1 1 0 001 1h6v2h-6a3 3 0 01-3-3V7a3 3 0 013-3h15zm-15 2a1 1 0 00-1 1v1.5h17V7a1 1 0 00-1-1h-15z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};